import React from 'react';
import { Section } from './Section';
export function OpeningHook() {
  return <div className="bg-darker border-y border-border relative" data-id="element-202">
      <Section className="max-w-4xl text-center" data-id="element-203">
        <div className="mb-8 flex justify-center" data-id="element-204">
          <div className="w-12 h-[1px] bg-blood" data-id="element-205"></div>
        </div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif leading-tight mb-10 text-foreground" data-id="element-206">
          Seguro te ha pasado: sales de una reunión o de una conversación
          sintiendo un vacío en el estómago. Sabes que te han pasado por encima.
          Sabes que esa "broma" fue un ataque a tu estatus. Y lo peor es que
          sonreíste porque no supiste cómo reaccionar.
        </h2>

        <p className="text-lg md:text-xl text-foreground/70 font-sans font-light leading-relaxed" data-id="element-207">
          La mayoría de la gente vive en un trance social, reaccionando a los
          hilos que otros tiran. Han sido educados para ser "buenos" y
          "complacientes", lo que en el mundo real se traduce como ser
          inofensivos y fáciles de usar.
        </p>
      </Section>
    </div>;
}